<script>
import { QExpansionItem, QItem, QCircularProgress } from "quasar";
export default {
  props: {
    nodes: {
      type: Array,
    },
    childkey: {
      type: String,
      default: "children",
    },
    labelKey: {
      type: String,
      default: "label",
    },
    nodeKey: {
      type: String,
      default: "id",
    },
    defaultExpandAll: {
      type: Boolean,
      default: false,
    },

    selectedNode: {
      type: String,
    },

    validatedAnswerCache: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      // selectedNode: null,
    };
  },

  model: {
    prop: "selectedNode",
    event: "change",
  },

  methods: {
    handleNodeCheck(node) {
      this.$emit("change", node[this.nodeKey]);
      // this.selectedNode = node[this.nodeKey];
    },
  },

  render(h) {
    const {
      childkey,
      nodes,
      labelKey,
      nodeKey,
      defaultExpandAll,
      selectedNode,
      validatedAnswerCache,
    } = this;

    const itemRender = (node) => {
      const questionsLoaded =
        Object.keys(validatedAnswerCache).indexOf(node.id) > -1;
      const answers = (validatedAnswerCache || {})[node.id] || {};
      const completedCount = Object.keys(answers).reduce((count, curr) => {
        if (answers[curr] && answers[curr].answer.length) count++;
        return count;
      }, 0);
      const pct = (completedCount / Object.keys(answers).length) * 100;
      const checked = selectedNode === node[nodeKey];
      return (
        <QItem
          dense
          clickable
          class={{
            "_tr-item-checked": checked,
          }}
          disable={node.empty}
          onclick={() => this.handleNodeCheck(node)}
        >
          <div class="full-width row items-center justify-between">
            <span>{node[labelKey]}</span>
            {node.empty ? (
              <span class="text-caption text-grey">(空)</span>
            ) : questionsLoaded ? (
              <div class="row items-center">
                <span
                  class={{
                    "q-mr-sm": true,
                    "text-caption": true,
                    "text-orange-6": checked,
                    "text-grey": !checked,
                  }}
                >
                  <span class={{ "text-red": !checked && pct !== 100 }}>
                    {completedCount}
                  </span>
                  <span>/</span>
                  <span>{Object.keys(answers).length}</span>
                </span>
                <QCircularProgress
                  show-value={false}
                  value={pct}
                  min={0}
                  max={100}
                  color={pct === 100 ? "green" : checked ? "white" : "primary"}
                  track-color={checked ? "orange-7" : "grey-4"}
                  thickness={1}
                />
              </div>
            ) : (
              <QCircularProgress
                show-value={false}
                value={100}
                min={0}
                max={100}
                color={checked ? "orange-7" : "grey-4"}
                track-color={checked ? "orange-7" : "grey-4"}
                thickness={1}
              />
            )}
          </div>
        </QItem>
      );
    };
    const nodeRender = (node, level = 1) => {
      if (Object.prototype.toString.call(node) === "[object Array]") {
        return node.map((_node) => nodeRender(_node, level));
      } else {
        if (node[childkey] && node[childkey].length) {
          return (
            <QExpansionItem
              label={node[labelKey]}
              content-inset-level={0.4}
              header-inset-level={0}
              expand-icon-toggle
              switch-toggle-side
              expand-icon="fas fa-angle-right"
              default-opened={defaultExpandAll}
            >
              <template slot="header">
                <div class="full-width">{itemRender(node)}</div>
              </template>

              <template slot="default">
                {node[childkey].map((_node) => nodeRender(_node, level + 1))}
              </template>
            </QExpansionItem>
          );
        } else {
          return itemRender(node);
        }
      }
    };
    return (
      <div class="tlqn-member-contents-custree column no-wrap">
        {nodeRender(nodes)}
      </div>
    );
  },
};
</script>

<style lang="scss">
@import "@/styles/quasar";
.tlqn-member-contents-custree {
  .q-item__section.q-focusable.q-item__section--avatar.q-item__section--side {
    width: 20px !important;
    height: 20px;
    padding-right: 0 !important;
    min-width: 20px;
    display: flex;
    align-self: center;
    justify-content: center;
  }
  .q-expansion-item__toggle-icon--rotated {
    transform: rotate(90deg) !important;
  }

  ._tr-item-checked {
    background-color: $primary;
    color: white;
  }
  .q-expansion-item__container > .q-item {
    padding-right: 0;
  }
}
</style>
